<template lang="pug">
v-row.py-6.px-1(no-gutters, justify='center')
  v-col
    v-expansion-panels(v-model='panel')
      v-expansion-panel.my-1(:key='0')
        person-expansion-header(
          :title='t("person.scientificActivities")',
          icon='mdi-school'
        )
        v-expansion-panel-text
          v-list-item(
            v-for='(programCommittee, i) in sortedProgramCommittee',
            :key='i'
          )
            
            v-list-item-title.my-1.text-subtitle.text-wrap
              | {{ programCommittee.label }}
            v-list-item-subtitle.text-wrap
              span
                | {{ programCommittee.description }}.
                | {{ programCommittee.location }},
                | {{ programCommittee.year }}
      v-expansion-panel.my-1(:key='1')
        person-expansion-header(
          :title='t("person.reviewActivities")',
          icon='mdi-file-find'
        )
        v-expansion-panel-text(
          v-for='(institution, i) in institutionTypes',
          :key='i'
        )
          v-list-item-title.my-1.text-subtitle
            | {{ institution.label }}
          ul
            li(
              v-for='(reviewer, i) in reviewForType(institution.type)',
              :key='i'
            )
              v-list-item-subtitle.my-1.font-weight-bold.activities-reviewer
                | {{ reviewer.label }}
</template>

<script setup>
defineOptions({
  name: 'PersonActivities',
})

const props = defineProps({
  activities: {
    type: Object,
    required: true,
  },
})

const panel = ref(0)
const { t } = useI18n()
const institutionTypes = computed(() => [
  { type: 'institution', label: t('person.fundingOrganizations') },
  { type: 'conference', label: t('person.conferences') },
  { type: 'journal', label: t('person.journals') },
])

const sortedProgramCommittee = computed(() => {
  const items = [...props.activities.programCommittee]
  // sort items by year
  return items.sort((a, b) => b.year - a.year)
})

function reviewForType(type) {
  return props.activities.reviewer.filter((reviewer) => reviewer.type === type)
}
</script>

<style scoped>
.activities-reviewer {
  color: var(--color-text-muted);
}
</style>
